const feedbackApi = '/feedback';

export const sendFeedback = () => feedbackApi;
